import React from 'react';
import UniBadge from './UniBadge';


/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */

// UniBtn UniBtnPack UniDesktop UniDesktopUnit UniDesktopFolder

/*
UniBtn PROPS:

props.href // href string	-	The URL to link to when the button is clicked. If defined, an <a> element will be used as the root node.

props.handleClick // (onClick handler function)

props.extraClass

props.renderDisabled
props.disabled
props.nonInteractive (non clickable and not hoverable. TODO alterantives dead/psssive/frozen)
props.active // (like an active/highlighted option in main menu TODO)
props.displayNone // (hidden by css display: none;)
props.overlayDisabled

props.wide // (minimum padding on left and right 16px by default)
props.fullWidth // (width 100%)
props.size // (16, 20, 24, 32, 40, 48, 64, 80, 96)

props.minWidth //

props.inline
props.circle
props.rectangle
props.outline
props.aura // (no background until hover)
props.tab // (rectangle shape, no background, border-bottom on hover)
props.tile // (like Microsoft Fluent 1 or Metro)
props.hazard

props.stickyContent // (TODO)

props.badgeContent
props.badgeDot
props.jsxBadge

props.i // (FontAwesome icon css class on <i> tag)
props.jsxIcon // (you can use any jsx as an icon)

props.titleBeforeIcon // (title on the left, icon on the right)
props.iconOnly // (dont display title)
props.titleOnly // (dont display icon)
props.iconAndTitle // (TODO)
props.titleOutsideHouse // (move title outside btn house in btn yard)

*/

/*
IDEAS / OLD IDEAS:

noPadding
link
text
underline
underlineOnHover

//
// TODO size in rems
rems={1}
2 je idealan za btn oko 2rem tj. 32px gde je font ikonice 20px a font teksta 14px.
1.5 je idealan za btn 1.5rem tj. 24px gde je font ikonice 16px a font teksta 14px.
1 je idealan za btn 1rem tj. 16px gde je font ikonice 12px a font teksta 12px.


disableElevation

themeButtonSubmit
themeButtonCancel
themeCustom


theme
quick theme
custom theme


// TODO

// TODO Btn with submeny, with submenu triangle icon, btn with dots Btn with custom tooltip, Btn, with 
props.showChildren


Pills badge 
pills vs circle

props.inlineSmall
props.inline
props.s
props.xs
props.xxs
props.xxxs
*/

// DEFAULT COMPONENT
const UniBtn = (props) => {
  if (props.renderDisabled === true) {
    return (<></>); // do not render anything
  }
  let href = null;
  if (typeof props.href === 'string') {
    href = props.href;
  }
  let handleClick = null;
  //
  let _clickable = true; //
  let _core_has_icon = false;
  let _core_has_title = false;
  let _core_has_both = false;
  let _tooltip = null;
  let _badge_content = false;
  let _is_badge_dot = false;
  //
  let cl = 'unicompo-btn';
  let cl_house = 'unicompo-btn__house';
  let jsxTitle = null;
  let jsxTtileOutsideHouse = null;
  // let jsxFontAwsome = null;
  let jsxIcon = null;
  //
  // ----- state
  if (props.disabled === true) {
    _clickable = false;
    cl += ' unicompo-btn--disabled';
    // handleClick = null;
  }
  if (props.nonInteractive === true) {
    _clickable = false;
    cl += ' unicompo-btn--non-interactive';
    // handleClick = null;
  }
  if (_clickable === true && typeof props.handleClick === 'function') {
    handleClick = props.handleClick;
    _clickable = true;
    cl += ' unicompo-btn--clickable';
  } else {
    _clickable = false;
  }
  if (props.active === true) {
    cl += ' unicompo-btn--active';
  }
  if (props.displayNone === true) {
    cl += ' unicompo-btn--display-none';
  }
  if (props.overlayDisabled === true) {
    cl += ' unicompo-btn--overlay-disabled';
  }
  //
  // ----- size
  if (props.wide === true) { // (minimum padding on left and right 16px by default)
    cl += " unicompo-btn--wide";
  }
  if (props.fullWidth === true) { // (width 100%)
    cl += " unicompo-btn--full-width";
  }
  if (props.size === 16 || props.size === "16") { // 1rem
    cl += ' unicompo-btn--size-16px';
  }
  if (props.size === 20 || props.size === "20") { // 1.25rem
    cl += ' unicompo-btn--size-20px';
  }
  if (props.size === 24 || props.size === "24") { // 1.5rem
    cl += ' unicompo-btn--size-24px';
  }
  if (props.size === 32 || props.size === "32") { // 2rem
    cl += ' unicompo-btn--size-32px';
  }
  if (props.size === 40 || props.size === "40") { // 2.5rem
    cl += ' unicompo-btn--size-40px';
  }
  if (props.size === 48 || props.size === "48") { // 3rem
    cl += ' unicompo-btn--size-48px';
  }
  /*
  if (props.size === 60 || props.size === "60") { // 3.75rem
    cl += ' unicompo-btn--size-60px';
  }
  */
  if (props.size === 64 || props.size === "64") { // 4rem
    cl += ' unicompo-btn--size-64px';
  }
  if (props.size === 80 || props.size === "80") { // 5rem
    cl += ' unicompo-btn--size-80px';
  }
  if (props.size === 96 || props.size === "96") { // 6rem
    cl += ' unicompo-btn--size-96px';
  }
  //
  // ----- shape amd visual variants etc...
  if (props.inline) {
    cl += ' unicompo-btn--inline';
  }
  if (props.circle) {
    cl += ' unicompo-btn--circle'
  }
  if (props.rectangle) {
    cl += ' unicompo-btn--rectangle'
  }
  if (props.outline === true) {
    cl += ' unicompo-btn--outline';
  }
  if (props.aura === true) {
    cl += ' unicompo-btn--aura';
  }
  if (props.tab === true) {
    cl += ' unicompo-btn--tab';
  }
  if (props.tile === true) {
    cl += ' unicompo-btn--tile';
  }
  if (props.hazard === true) {
    cl += ' unicompo-btn--hazard';
  }
  //
  // ----- special... TODO
  if (props.stickyContent === true) {
    cl += ' unicompo-btn--sticky-content';
  }
  //
  // ----- badge
  if ((typeof props.badgeContent === 'string' && props.badgeContent !== '') || typeof props.badgeContent === 'number') {
    _badge_content = props.badgeContent;
  }
  if (props.badgeDot === true) {
    _is_badge_dot = true;
    _badge_content = false;
  }
  if (props.jsxBadge) {
    _is_badge_dot = false;
    _badge_content = props.jsxBadge;
  }

  // ----- icon title and tooltip
  // if (typeof props.tooltip === 'string' && props.tooltip !== '') {
  if ((typeof props.tooltip === 'string' && props.tooltip !== '') || typeof props.tooltip === 'number') {
    _tooltip = props.tooltip;
    cl_house += ' unicompo-btn__house--special-data-tooltip';
  }
  if (props.iconOnly === true) {
    // _core_has_icon = true; // TODO
    _core_has_title = false;
  } else {
    if (typeof props.title === 'string' && props.title !== '') {
      if (props.titleOutsideHouse === true) {
        _core_has_title = false;
        cl += ' unicompo-btn--title-outside-house';
        jsxTtileOutsideHouse = (
          <div className="unicompo-btn__title-outside-container">
            <span className="unicompo-btn__title">{props.title}</span>
          </div>
        );
      } else {
        _core_has_title = true;
        jsxTitle = (
          <span className="unicompo-btn__title">{props.title}</span>
        );
      }
    }
  }
  if (props.titleOnly === true) {
    // _core_has_title = true; // TODO
    _core_has_icon = false;
  } else {
    if (typeof props.i === 'string' && props.i !== '') {
      _core_has_icon = true;
      jsxIcon = (
        <span className="unicompo-btn__icon-container">
          <i className={props.i} aria-hidden="true"></i>
        </span>
      );
    }
    if (props.jsxIcon) {
      _core_has_icon = true;
      // jsxIcon = props.jsxIcon;
      jsxIcon = (
        <div className="unicompo-btn__icon-container">
          {props.jsxIcon}
        </div>
      );
    }
  }
  if (_core_has_title) {
    cl += ' unicompo-btn--with-title';
  }
  if (_core_has_icon && _core_has_title) {
    _core_has_both = true;
    cl += ' unicompo-btn--icon-and-title';
  }
  if (props.titleBeforeIcon === true) { // reverse order
    cl += ' unicompo-btn--title-before-icon';
  }


  //
  if (typeof props.extraClass === 'string' && props.extraClass !== '') {
    cl += ' ' + props.extraClass;
  }

  //
  // ----- colors and themeCompo

  if (props.themeCompoColorRed === true) {
    cl += ' unicompo-btn--themecompo-color-red';
  }
  if (props.themeCompoColorIndigo === true) {
    cl += ' unicompo-btn--themecompo-color-indigo';
  }
  if (props.themeCompoColorBlue === true) {
    cl += ' unicompo-btn--themecompo-color-blue';
  }
  if (props.themeCompoColorGreen === true) {
    cl += ' unicompo-btn--themecompo-color-green';
  }


  // ---------- OLD

  if (props.btnDialogCancel === true) {
    cl += ' unicompo-btn--dialog-cancel';
  }
  if (props.btnDialogSubmit === true) {
    cl += ' unicompo-btn--dialog-submit';
  }

  if (props.btnSmallWithTitle === true) {
    cl += ' unicompo-btn--small-with-title';
    _core_has_title = true;
  }

  ////

  // TODO
  let style = {};
  if (props.minWidth > 0) {
    style = {
      minWidth: props.minWidth
    };
  }


  // ---------- render ----------
  //
  let jsxContent = null;
  if (_core_has_both) {
    jsxContent = (
      <>
        {jsxIcon}
        <span className="unicompo-btn__content__gap"></span>
        {jsxTitle}
      </>
    );
  } else {
    jsxContent = (
      <>
        {jsxIcon}
        {jsxTitle}
      </>
    );
  }

  const jsxInsideA = (
    <>
      <div className="unicompo-btn__yard">
        <div className={cl_house} data-tooltip={_tooltip}>
          <div className="unicompo-btn__overlay">
          </div>
          <div className="unicompo-btn__core">
            {jsxContent}
          </div>
          {/* {
            _badge_content && (
              <div className="unicompo-btn__badge-origin">
                <div className="unicompo-btn__badge-container">
                  <UniBadge
                    badgeContent={_badge_content}
                  />
                </div>
              </div>
            )
          } */}
          {
            _is_badge_dot && (
              <div className="unicompo-btn__badge-origin">
                <div className="unicompo-btn__badge-container">
                  <UniBadge
                    badgeDot={props.badgeDot}
                  />
                </div>
              </div>
            )
          }
        </div>
        {jsxTtileOutsideHouse}
      </div>
    </>
  );

  if (href) {
    return (
      <a
        className={cl}
        onClick={handleClick}
        style={style}
        data-href={href}
        href={href}
      >{jsxInsideA}</a>
    );
  } else {
    return (
      <div
        className={cl}
        onClick={handleClick}
        style={style}
      >{jsxInsideA}</div>
    );
  }
};

export default UniBtn;


/*
UniBtnSoftDeleteToggle PROPS:
props.flagDeleted   // (boolean) current _master_flag_deleted value
props.handleActivate    // called when user clicks to activate (flagDeleted was true)
props.handleDeactivate  // called when user clicks to deactivate (flagDeleted was false)
// forwarded to UniBtn: size, inline, extraClass, ...
*/
export const UniBtnSoftDeleteToggle = (props) => {
  const isDeleted = props.flagDeleted === true;
  return (
    <UniBtn
      inline={props.inline !== false}
      size={props.size !== undefined ? props.size : 24}
      iconOnly
      themeCompoColorRed
      extraClass={props.extraClass}
      i={isDeleted ? 'fa fa-toggle-on' : 'fa fa-toggle-off'}
      tooltip={isDeleted ? 'Activate SOFT' : 'Deactivate SOFT'}
      title={isDeleted ? 'Activate' : 'Deactivate'}
      handleClick={isDeleted ? props.handleActivate : props.handleDeactivate}
    />
  );
};


//
/*
UniBtnPack PROPS:
props.pill
props.rectangle
props.tabs
props.tabsVertical
*/
export const UniBtnPack = (props) => {
  let cl = 'unicompo-btn-pack';
  if (props.pill === true) {
    cl += ' unicompo-btn-pack--pill';
  }
  if (props.rectangle === true) {
    cl += ' unicompo-btn-pack--rectangle';
  }
  if (props.tabs === true) {
    cl += ' unicompo-btn-pack--tabs';
  }
  if (props.tabsVertical === true) {
    cl += ' unicompo-btn-pack--tabs-vertical';
  }
  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    // extraClass = ' ' + props.extraClass;
    cl += ' ' + props.extraClass;
  }
  return (
    <div className={cl}>{props.children}</div>
  );
};


// UniBtnMix - combine two different buttons with two different onClick events
export const UniBtnMix = (props) => {
  let cl = 'unicompo-btn-mix';
  if (props.tile === true) {
    cl += ' unicompo-btn-mix--tile';
  }
  if (props.secondUnderFirst === true) {
    cl += ' unicompo-btn-mix--btn2-under-btn1';
  }
  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    // extraClass = ' ' + props.extraClass;
    cl += ' ' + props.extraClass;
  }
  let jsxBtn1 = null;
  let jsxBtn2 = null;
  if (props.jsxBtn1) {
    jsxBtn1 = props.jsxBtn1;
  }
  if (props.jsxBtn2) {
    jsxBtn2 = props.jsxBtn2;
  }
  return (
    <div className={cl}>
      <div className="unicompo-btn-mix__btn1">{jsxBtn1}</div>
      <div className="unicompo-btn-mix__gap"></div>
      <div className="unicompo-btn-mix__btn2">{jsxBtn2}</div>
    </div>
  );
};


//
export const UniDesktop = (props) => {
  return (
    <>
    </>
  );
};


//
export const UniDesktopUnit = (props) => {
  return (
    <div className={"unicompo-desktop__unit" + (props.col === true ? " unicompo-desktop__unit--col" : " unicompo-desktop__unit--row")}>{props.children}</div>
  );
};


//
export const UniDesktopFolder = (props) => {
  return (
    <>
      <div className="unicompo-desktop__folder-bg"></div>
      {props.children}
    </>
  );
};